export default __webpack_public_path__ + "static/media/andreaHinnen.c54674a0.png";